<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <b-row>
              <b-col lg="8" class="my-1">
                <b-button v-if="modulePermission.create == 1" @click="AddOwnership()" class="btn-outline-primary">
                  <b-icon class="text-center" icon="plus"></b-icon> New Ownership
                </b-button>
            </b-col>
             <b-col lg="4" class="my-1">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Filter"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            
            <template>
              <div class="table-container">
                <b-table-simple
                  :small="true"
                  sticky-header
                  style="max-height: 400px;"
                  striped
                  responsive
                  hover
                >
                  <b-thead>
                    <b-tr>
                      <b-th>No.</b-th>
                      <b-th>Unique Id</b-th>
                      <b-th>Owner Name</b-th>
                      <b-th>House</b-th>
                      <b-th>Start Date</b-th>
                      <b-th>Payment Date</b-th>
                      <b-th>Payment Status</b-th>
                      <b-th>Repayment Amount</b-th>
                      <b-th>Registered By</b-th>
                      <b-th sticky-column style="height: 45px;"></b-th>
                    </b-tr>
                  </b-thead>
                <template v-if="spinner">
                <b-tbody>
                   <b-tr >
                       <b-td colspan="9" class="text-center" style="display: table-cell">
                        <b-spinner
                        style="height: 3rem; width: 3rem;"
                          variant="warning"
                        ></b-spinner>
                       </b-td>
                    </b-tr>
                </b-tbody>
                </template>
                <template v-else>
                  <b-tbody>
                  <template v-if="filterTable.length === 0">
                      <b-tr>
                        <b-td colspan="9" class="text-center">Nothing found</b-td>
                      </b-tr>
                  </template>
                  <template v-else>
                  <b-tr
                    v-for="(item, index) in filterTable"
                    :key="item.id"
                  >
                      <b-td>{{++index}}</b-td>
                      <b-td>{{item.uniqueId}}</b-td>
                      <b-td>{{item.owner.fullName}}</b-td>
                      <b-td>{{item.house.building.name}} - Room {{item.house.roomNumber}}</b-td>
                      <b-td>{{item.startDate}}</b-td>
                      <b-td>{{item.paymentDate}}</b-td>
                      <b-td>
                        <span :class="item.paymentStatus === 'Paid' ? 'text-success' : 'text-danger'">
                          {{item.paymentStatus}}
                        </span>
                      </b-td>
                      <b-td>{{item.repaymentAmount}}</b-td>
                      <b-td>{{item.registeredBy}}</b-td>
                      <b-td sticky-column style="padding: 0px 0px !important;">
                        <b-row>
                          <b-col md="12" class="mb-2" v-if="modulePermission.update == 1">
                            <b-icon icon="pencil-square" class="btn-icon" title="Edit Ownership" @click="EditOwnership(item.id)" aria-hidden="true" ></b-icon>
                          </b-col>
                        </b-row>
                      </b-td>
                  </b-tr>
                  </template>
                </b-tbody>
                </template>
                </b-table-simple>
              </div>
              <div class="pagination-container mt-3">
                <b-row>
                  <b-col md="3">
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols="8" label-cols-xs="8" label-size="md"
                      label="records per page"
                      label-for="input-horizontal"
                      label-align-xl="right"  
                    >
                    <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="9">
                    <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" @page-click="changePage" align="right"></b-pagination>
                  </b-col>
                </b-row>
              </div>
            </template>
          </card>
        </div>
      </div>
      <div class="row">
        <b-modal
            id="modal-center-add"
            hide-footer
            :title="currentStep === 4 ? 'Preview Ownership Information' : 'Add Ownership - Step ' + currentStep"
            content-class="shadow"
            size="xl"
          >
            <template #modal-header="{ close }">
              <h5>{{ currentStep === 4 ? 'Preview Ownership Information' : 'Add Ownership - Step ' + currentStep }}</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            
            <!-- Step Progress Indicator -->
            <div class="step-progress mb-3" v-if="currentStep < 4">
              <div class="step" :class="{ active: currentStep >= 1 }">1</div>
              <div class="step-line" :class="{ active: currentStep >= 2 }"></div>
              <div class="step" :class="{ active: currentStep >= 2 }">2</div>
              <div class="step-line" :class="{ active: currentStep >= 3 }"></div>
              <div class="step" :class="{ active: currentStep >= 3 }">3</div>
              <div class="step-line" :class="{ active: currentStep >= 4 }"></div>
              <div class="step" :class="{ active: currentStep >= 4 }">4</div>
            </div>

            <!-- Step 1: Owner Selection -->
            <div v-if="currentStep === 1">
              <validation-observer ref="step1Observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(nextStep)">
                  <b-row no-gutters>
                    <b-col md="12">
                      <b-form-group label="Owner Type" class="mb-2">
                        <b-form-radio-group v-model="ownerType" :options="ownerTypeOptions" @change="resetOwnerData"></b-form-radio-group>
                      </b-form-group>
                    </b-col>
                    
                    <template v-if="ownerType === 'existing'">
                      <b-col md="12">
                        <Vselect
                          :modelValue="addData.ownerId"
                          @update:modelValue="(newValue) => (addData.ownerId = newValue)"
                          :options="ownerOptions"
                          :rules="{ required: true }"
                          id="text-owner"
                          name="text-owner"
                          label="Select Existing Owner"
                          class="mb-1 mr-sm-2"
                          description="text-owner-feedback"
                          validatorName="Owner"
                        />
                      </b-col>
                    </template>
                    
                    <template v-else>
                      <b-col md="6">
                        <Vinput
                          :modelValue="newOwner.firstName"
                          @update:modelValue="(newValue) => (newOwner.firstName = newValue)"
                          :rules="{ required: true }"
                          id="text-firstName"
                          name="text-firstName"
                          label="First Name"
                          class="mb-1 mr-sm-2"
                          description="text-firstName-feedback"
                          validatorName="First Name"
                        />
                      </b-col>
                      <b-col md="6">
                        <Vinput
                          :modelValue="newOwner.lastName"
                          @update:modelValue="(newValue) => (newOwner.lastName = newValue)"
                          :rules="{ required: true }"
                          id="text-lastName"
                          name="text-lastName"
                          label="Last Name"
                          class="mb-1 mr-sm-2"
                          description="text-lastName-feedback"
                          validatorName="Last Name"
                        />
                      </b-col>
                      <b-col md="12">
                        <VinputGroup
                          inputType="text"
                          :modelValue="newOwner.phoneNumber"
                          @update:modelValue="(newValue) => (newOwner.phoneNumber = newValue)"
                          :rules="{ required: true, regex:/^\d{9}$/ }"
                          id="text-phone"
                          name="text-phone"
                          label="Phone Number"
                          class="mb-1 mr-sm-2"
                          description="text-phone-feedback"
                          validatorName="Phone Number"
                          prepend="+251"
                        />
                      </b-col>
                      <b-col md="12">
                        <Vinput
                          :modelValue="newOwner.email"
                          @update:modelValue="(newValue) => (newOwner.email = newValue)"
                          id="text-email"
                          name="text-email"
                          label="Email"
                          class="mb-1 mr-sm-2"
                          description="text-email-feedback"
                          validatorName="Email"
                        />
                      </b-col>
                      <b-col md="12">
                        <Vinput
                          :modelValue="newOwner.address"
                          @update:modelValue="(newValue) => (newOwner.address = newValue)"
                          :rules="{ required: true }"
                          id="text-address"
                          name="text-address"
                          label="Address"
                          class="mb-1 mr-sm-2"
                          description="text-address-feedback"
                          validatorName="Address"
                        />
                      </b-col>
                      <b-col md="6">
                        <Vselect
                          :modelValue="newOwner.sex"
                          @update:modelValue="(newValue) => (newOwner.sex = newValue)"
                          :options="sexOptions"
                          id="text-sex"
                          name="text-sex"
                          label="Gender"
                          class="mb-1 mr-sm-2"
                          description="text-sex-feedback"
                          validatorName="Gender"
                        />
                      </b-col>
                      <b-col md="6">
                        <Vselect
                          :modelValue="newOwner.status"
                          @update:modelValue="(newValue) => (newOwner.status = newValue)"
                          :options="statusOptions"
                          id="text-status"
                          name="text-status"
                          label="Status"
                          class="mb-1 mr-sm-2"
                          description="text-status-feedback"
                          validatorName="Status"
                        />
                      </b-col>
                    </template>
                    <b-col class="mt-2 d-flex justify-content-between">
                      <b-button variant="secondary" @click="previousStep" :disabled="currentStep === 1">Previous</b-button>
                      <b-button type="submit" variant="primary" :disabled="!canProceedToNext">Next</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </div>

            <!-- Step 2: House Selection -->
            <div v-if="currentStep === 2">
              <validation-observer ref="step2Observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(nextStep)">
                  <b-row no-gutters>

                    <b-col md="12">
                      <b-form-group label="House Type" class="mb-2">
                        <b-form-radio-group v-model="houseType" :options="houseTypeOptions" @change="resetHouseData"></b-form-radio-group>
                      </b-form-group>
                    </b-col>
                    
                    <template v-if="houseType === 'existing'">
                      <b-col md="12">
                        <Vselect
                          :modelValue="addData.houseId"
                          @update:modelValue="(newValue) => (addData.houseId = newValue)"
                          :options="houseOptions"
                          :rules="{ required: true }"
                          id="text-house"
                          name="text-house"
                          label="Select Existing House"
                          class="mb-1 mr-sm-2"
                          description="text-house-feedback"
                          validatorName="House"
                        />
                      </b-col>
                    </template>
                    
                    <template v-else>
                      <b-col md="12">
                        <Vselect
                          :modelValue="newHouse.buildingId"
                          @update:modelValue="(newValue) => (newHouse.buildingId = newValue)"
                          :options="buildingOptions"
                          :rules="{ required: true }"
                          id="text-building"
                          name="text-building"
                          label="Building"
                          class="mb-1 mr-sm-2"
                          description="text-building-feedback"
                          validatorName="Building"
                        />
                      </b-col>
                      <b-col md="6">
                        <VinputNumber
                          :modelValue="newHouse.roomNumber"
                          @update:modelValue="(newValue) => (newHouse.roomNumber = newValue)"
                          :rules="{ required: true }"
                          id="text-roomNumber"
                          name="text-roomNumber"
                          label="Room Number"
                          class="mb-1 mr-sm-2"
                          description="text-roomNumber-feedback"
                          validatorName="Room Number"
                        />
                      </b-col>
                      <b-col md="6">
                        <VinputNumber
                          :modelValue="newHouse.floor"
                          @update:modelValue="(newValue) => (newHouse.floor = newValue)"
                          :rules="{ required: true }"
                          id="text-floor"
                          name="text-floor"
                          label="Floor"
                          class="mb-1 mr-sm-2"
                          description="text-floor-feedback"
                          validatorName="Floor"
                        />
                      </b-col>
                      <b-col md="12">
                        <VinputNumber
                          :modelValue="newHouse.size"
                          @update:modelValue="(newValue) => (newHouse.size = newValue)"
                          id="text-size"
                          name="text-size"
                          label="House Size (sq ft)"
                          class="mb-1 mr-sm-2"
                          description="text-size-feedback"
                          validatorName="House Size"
                          :step=".01"
                        />
                      </b-col>
                    </template>
                    <b-col class="mt-2 d-flex justify-content-between">
                      <b-button variant="secondary" @click="previousStep">Previous</b-button>
                      <b-button type="submit" variant="primary" :disabled="!canProceedToNext">Next</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </div>

            <!-- Step 3: Ownership Details & Penalty Settings -->
            <div v-if="currentStep === 3">
              <validation-observer ref="step3Observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(nextStep)">
                  <b-row no-gutters>

                    <b-col md="12"><h6>Ownership Details</h6></b-col>
                    <b-col md="6">
                      <Vinput
                        inputType="date"
                        :modelValue="addData.startDate"
                        @update:modelValue="(newValue) => (addData.startDate = newValue)"
                        :rules="{ required: true }"
                        id="text-startDate"
                        name="text-startDate"
                        label="Start Date"
                        class="mb-1 mr-sm-2"
                        description="text-startDate-feedback"
                        validatorName="Start Date"
                      />
                    </b-col>
                    <b-col md="6">
                      <VinputNumber
                        :modelValue="addData.repaymentAmount"
                        @update:modelValue="(newValue) => (addData.repaymentAmount = newValue)"
                        :rules="{ required: true, min_value: 1 }"
                        id="text-repaymentAmount"
                        name="text-repaymentAmount"
                        label="Repayment Amount"
                        class="mb-1 mr-sm-2"
                        description="text-repaymentAmount-feedback"
                        validatorName="Repayment Amount"
                        :step="1"
                      />
                    </b-col>
                    <b-col md="6">
                      <Vselect
                        :modelValue="addData.repaymentFrequency"
                        @update:modelValue="(newValue) => (addData.repaymentFrequency = newValue)"
                        :options="frequencyOptions"
                        :rules="{ required: true }"
                        id="text-frequency"
                        name="text-frequency"
                        label="Repayment Frequency"
                        class="mb-1 mr-sm-2"
                        description="text-frequency-feedback"
                        validatorName="Repayment Frequency"
                      />
                    </b-col>
                    <b-col md="6">
                      <Vinput
                        inputType="range"
                        :modelValue="addData.gracePeriod"
                        @update:modelValue="(newValue) => (addData.gracePeriod = newValue)"
                        id="text-gracePeriod"
                        name="text-gracePeriod"
                        :label="`Grace Period: ${addData.gracePeriod || 0} days`"
                        class="mb-1 mr-sm-2"
                        description="text-gracePeriod-feedback"
                        validatorName="Grace Period"
                        min="0"
                        max="30"
                        step="1"
                        :title="addData.gracePeriod"
                      />
                    </b-col>
                    <b-col md="12">
                      <VinputNumber
                        :modelValue="addData.unpaidTotalAmount"
                        @update:modelValue="(newValue) => (addData.unpaidTotalAmount = newValue)"
                        :rules="{ required: true, min_value: (addData.repaymentAmount || 0)}"
                        id="text-unpaidAmount"
                        name="text-unpaidAmount"
                        label="Unpaid Total Amount"
                        class="mb-1 mr-sm-2"
                        description="text-unpaidAmount-feedback"
                        validatorName="Unpaid Total Amount"
                        :step="1"
                      />
                    </b-col>
                    
                    <b-col md="12"><hr><h6>Penalty Settings</h6></b-col>
                    <b-col md="12">
                      <b-form-checkbox v-model="addData.hasPenalty" @change="resetPenaltyData">
                        Has Penalty
                      </b-form-checkbox>
                    </b-col>
                    
                    <template v-if="addData.hasPenalty">
                      <b-col md="6">
                        <Vselect
                          :modelValue="addData.penaltyType"
                          @update:modelValue="(newValue) => (addData.penaltyType = newValue)"
                          :options="penaltyTypeOptions"
                          :rules="{ required: true }"
                          id="text-penaltyType"
                          name="text-penaltyType"
                          label="Penalty Type"
                          class="mb-1 mr-sm-2"
                          description="text-penaltyType-feedback"
                          validatorName="Penalty Type"
                        />
                      </b-col>
                      <b-col md="6">
                        <Vselect
                          :modelValue="addData.penaltyBase"
                          @update:modelValue="(newValue) => (addData.penaltyBase = newValue)"
                          :options="penaltyBaseOptions"
                          :rules="{ required: true }"
                          id="text-penaltyBase"
                          name="text-penaltyBase"
                          label="Penalty Base"
                          class="mb-1 mr-sm-2"
                          description="text-penaltyBase-feedback"
                          validatorName="Penalty Base"
                        />
                      </b-col>
                      <b-col md="6">
                        <Vselect
                          :modelValue="addData.penaltyAmount"
                          @update:modelValue="(newValue) => (addData.penaltyAmount = newValue)"
                          :options="addData.penaltyBase === 'Percentage' ? penaltyPercentageOptions : penaltyFixedOptions"
                          :rules="{ required: true }"
                          id="text-penaltyAmount"
                          name="text-penaltyAmount"
                          label="Penalty Amount"
                          class="mb-1 mr-sm-2"
                          description="text-penaltyAmount-feedback"
                          validatorName="Penalty Amount"
                        />
                      </b-col>
                      <b-col md="6" v-if="addData.penaltyAmount === 'Other'">
                        <VinputNumber
                          :modelValue="addData.customPenaltyAmount"
                          @update:modelValue="(newValue) => (addData.customPenaltyAmount = newValue)"
                          :rules="{ required: true }"
                          id="text-customPenaltyAmount"
                          name="text-customPenaltyAmount"
                          label="Custom Penalty Amount"
                          class="mb-1 mr-sm-2"
                          description="text-customPenaltyAmount-feedback"
                          validatorName="Custom Penalty Amount"
                          :step=".01"
                        />
                      </b-col>
                      <b-col md="6" v-if="addData.penaltyType === 'Incremental'">
                        <Vselect
                          :modelValue="addData.penaltyIncrementDays"
                          @update:modelValue="(newValue) => (addData.penaltyIncrementDays = newValue)"
                          :options="penaltyIncrementDaysOptions"
                          :rules="{ required: true }"
                          id="text-penaltyIncrementDays"
                          name="text-penaltyIncrementDays"
                          label="Penalty Increment Days"
                          class="mb-1 mr-sm-2"
                          description="text-penaltyIncrementDays-feedback"
                          validatorName="Penalty Increment Days"
                        />
                      </b-col>
                      <b-col md="6" v-if="addData.penaltyType === 'Incremental' && addData.penaltyIncrementDays === 'Other'">
                        <VinputNumber
                          :modelValue="addData.customPenaltyIncrementDays"
                          @update:modelValue="(newValue) => (addData.customPenaltyIncrementDays = newValue)"
                          :rules="{ required: true }"
                          id="text-customPenaltyIncrementDays"
                          name="text-customPenaltyIncrementDays"
                          label="Custom Penalty Increment Days"
                          class="mb-1 mr-sm-2"
                          description="text-customPenaltyIncrementDays-feedback"
                          validatorName="Custom Penalty Increment Days"
                        />
                      </b-col>
                    </template>
                    
                    <b-col md="12">
                      <Vinput
                        inputType="textarea"
                        :modelValue="addData.description"
                        @update:modelValue="(newValue) => (addData.description = newValue)"
                        id="text-description"
                        name="text-description"
                        label="Description"
                        class="mb-1 mr-sm-2"
                        description="text-description-feedback"
                        validatorName="Description"
                      />
                    </b-col>
                    <b-col class="mt-2 d-flex justify-content-between">
                      <b-button variant="secondary" @click="previousStep">Previous</b-button>
                      <b-button type="submit" variant="primary" :disabled="!canProceedToNext">Preview</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </div>

            <!-- Step 4: Ownership Review -->
            <div v-if="currentStep === 4">
              <div class="contract-review-section">
                <div class="text-center mb-3">
                  <h6 class="section-title" style="color: rgb(37, 91, 48) !important;">
                    <b-icon icon="file-pdf"></b-icon> Ownership Agreement Review
                  </h6>
                </div>
                <div class="contract-review-container">
                  <div class="text-center mb-4">
                    <h4 class="text-primary">Property Ownership Agreement Review</h4>
                    <p class="text-muted">Please review all ownership details before submission</p>
                  </div>
                        <!-- Contract Summary Document -->
                        <div class="contract-document bg-light p-4 rounded border" id="pdf-content">
                          <div class="document-header text-center mb-4">
                            <h5 class="text-primary mb-1">PROPERTY OWNERSHIP AGREEMENT</h5>
                            <p class="text-muted small">This agreement establishes ownership terms, payment schedule, and penalty conditions for the specified property</p>
                          </div>
                          
                          <!-- Action Buttons -->
                          <div class="text-center mb-4">
                            <b-button-group>
                              <b-button variant="outline-primary" @click="printOwnership">
                                <b-icon icon="printer"></b-icon> Print Agreement
                              </b-button>
                              <b-button variant="outline-success" @click="downloadOwnership">
                                <b-icon icon="download"></b-icon> Download PDF
                              </b-button>
                            </b-button-group>
                          </div>

                          <!-- Parties Section -->
                          <div class="contract-section mb-4">
                            <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                              <b-icon icon="people-fill"></b-icon> PARTIES TO THE AGREEMENT
                            </h6>
                            <b-card no-body class="border-0">
                              <b-row no-gutters>
                                <b-col md="6">
                                  <b-card class="h-100 border-primary">
                                    <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">PROPERTY MANAGER</h6>
                                    <b-row>
                                      <b-col cols="6"><strong>Name:</strong></b-col>
                                      <b-col cols="6">Property Management Company</b-col>
                                      <b-col cols="6"><strong>Role:</strong></b-col>
                                      <b-col cols="6">Property Administrator</b-col>
                                      <b-col cols="6"><strong>Rep. by:</strong></b-col>
                                      <b-col cols="6">{{ getCurrentUserName() }}</b-col>
                                    </b-row>
                                  </b-card>
                                </b-col>
                                <b-col md="6">
                                  <b-card class="h-100 border-primary">
                                    <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">PROPERTY OWNER</h6>
                                    <template v-if="ownerType === 'existing'">
                                      <b-row>
                                        <b-col cols="6"><strong>Name:</strong></b-col>
                                        <b-col cols="6">{{ getOwnerName(addData.ownerId) }}</b-col>
                                        <b-col cols="6"><strong>Role:</strong></b-col>
                                        <b-col cols="6">Property Owner</b-col>
                                        <b-col cols="6"><strong>Status:</strong></b-col>
                                        <b-col cols="6">Existing</b-col>
                                      </b-row>
                                    </template>
                                    <template v-else>
                                      <b-row>
                                        <b-col cols="6"><strong>Name:</strong></b-col>
                                        <b-col cols="6">{{ newOwner.firstName }} {{ newOwner.lastName }}</b-col>
                                        <b-col cols="6"><strong>Email:</strong></b-col>
                                        <b-col cols="6">{{ newOwner.email || 'Not provided' }}</b-col>
                                        <b-col cols="6"><strong>Phone:</strong></b-col>
                                        <b-col cols="6">+251{{ newOwner.phoneNumber }}</b-col>
                                        <b-col cols="6"><strong>Address:</strong></b-col>
                                        <b-col cols="6">{{ newOwner.address }}</b-col>
                                        <b-col cols="6"><strong>Gender:</strong></b-col>
                                        <b-col cols="6">{{ newOwner.sex }}</b-col>
                                      </b-row>
                                    </template>
                                  </b-card>
                                </b-col>
                              </b-row>
                            </b-card>
                          </div>

                          <!-- Property Section -->
                          <div class="contract-section mb-4">
                            <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                              <b-icon icon="house-door"></b-icon> PROPERTY DETAILS
                            </h6>
                            <b-card class="border-primary">
                              <h6 class="text-white mb-3 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Property Description</h6>
                              <p class="mb-3">The following property is being registered for ownership under this agreement:</p>
                              
                              <template v-if="houseType === 'existing'">
                                <b-row>
                                  <b-col cols="4"><strong>Property:</strong></b-col>
                                  <b-col cols="8">{{ getHouseName(addData.houseId) }}</b-col>
                                  <b-col cols="4"><strong>Status:</strong></b-col>
                                  <b-col cols="8">Available for ownership transfer</b-col>
                                </b-row>
                              </template>
                              <template v-else>
                                <b-row>
                                  <b-col cols="4"><strong>Building:</strong></b-col>
                                  <b-col cols="8">{{ getBuildingName(newHouse.buildingId) }}</b-col>
                                  <b-col cols="4"><strong>Floor:</strong></b-col>
                                  <b-col cols="8">{{ newHouse.floor }}{{ getFloorSuffix(newHouse.floor) }} Floor</b-col>
                                  <b-col cols="4"><strong>Room:</strong></b-col>
                                  <b-col cols="8">{{ newHouse.roomNumber }}</b-col>
                                  <b-col cols="4"><strong>Size:</strong></b-col>
                                  <b-col cols="8">{{ newHouse.size }} sq.ft</b-col>
                                  <b-col v-if="addData.description" cols="4"><strong>Description:</strong></b-col>
                                  <b-col v-if="addData.description" cols="8">{{ addData.description }}</b-col>
                                </b-row>
                              </template>
                            </b-card>
                          </div>
                          
                          <!-- Terms and Conditions Section -->
                          <div class="contract-section mb-4">
                            <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                              <b-icon icon="file-text"></b-icon> OWNERSHIP TERMS AND CONDITIONS
                            </h6>
                            <b-row>
                              <b-col md="6">
                                <b-card class="h-100 border-primary">
                                  <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Ownership Period</h6>
                                  <p class="mb-3">This ownership agreement shall commence on <strong>{{ addData.startDate }}</strong> and continue until full payment completion.</p>
                                  
                                  <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Payment Terms</h6>
                                  <b-row class="mb-2">
                                    <b-col cols="6"><strong>Frequency:</strong></b-col>
                                    <b-col cols="6">{{ addData.repaymentFrequency }}</b-col>
                                    <b-col cols="6"><strong>Amount:</strong></b-col>
                                    <b-col cols="6">{{ numberWithCommas(addData.repaymentAmount) }} ETB</b-col>
                                    <b-col cols="6"><strong>Grace Period:</strong></b-col>
                                    <b-col cols="6">{{ addData.gracePeriod }} days</b-col>
                                    <b-col cols="6"><strong>Total Due:</strong></b-col>
                                    <b-col cols="6">{{ numberWithCommas(addData.unpaidTotalAmount) }} ETB</b-col>
                                  </b-row>
                                </b-card>
                              </b-col>
                              
                              <b-col md="6">
                                <b-card class="h-100 border-primary">
                                  <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Penalty Conditions</h6>
                                  <b-row class="mb-2">
                                    <b-col cols="6"><strong>Penalty:</strong></b-col>
                                    <b-col cols="6">{{ addData.hasPenalty ? 'Enabled' : 'Disabled' }}</b-col>
                                    <template v-if="addData.hasPenalty">
                                      <b-col cols="6"><strong>Type:</strong></b-col>
                                      <b-col cols="6">{{ addData.penaltyType }}</b-col>
                                      <b-col cols="6"><strong>Base:</strong></b-col>
                                      <b-col cols="6">{{ addData.penaltyBase }}</b-col>
                                      <b-col cols="6"><strong>Amount:</strong></b-col>
                                      <b-col cols="6">{{ addData.penaltyAmount === 'Other' ? addData.customPenaltyAmount : addData.penaltyAmount }}{{ addData.penaltyBase === 'Percentage' ? '%' : ' ETB' }}</b-col>
                                    </template>
                                  </b-row>
                                </b-card>
                              </b-col>
                            </b-row>
                          </div>
                          
                          <!-- Payment Method Section -->
                          <div class="contract-section mb-4">
                            <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                              <b-icon icon="credit-card"></b-icon> PAYMENT METHOD AND BANKING INFORMATION
                            </h6>
                            <b-card class="border-primary">
                              <div class="alert alert-info mb-3">
                                <strong>Payment Method:</strong> All ownership payments must be made through Tsehay Bank using any of the following convenient channels:
                              </div>
                              <b-row>
                                <b-col md="6">
                                  <table class="table table-sm">
                                    <tr><td class="font-weight-bold">Mobile Banking</td><td>Use Tsehay Bank mobile app for instant payments</td></tr>
                                    <tr><td class="font-weight-bold">Internet Banking</td><td>Access online banking portal for secure transactions</td></tr>
                                    <tr><td class="font-weight-bold">USSD Banking</td><td>Dial USSD code for quick mobile payments</td></tr>
                                  </table>
                                </b-col>
                                <b-col md="6">
                                  <table class="table table-sm">
                                    <tr><td class="font-weight-bold">Branch Services</td><td>Visit any Tsehay Bank branch for in-person payments</td></tr>
                                    <tr><td class="font-weight-bold">ATM Services</td><td>Use Tsehay Bank ATMs for payment transactions</td></tr>
                                    <tr><td class="font-weight-bold">Payment Reference</td><td>A unique payment ID will be provided after agreement establishment</td></tr>
                                  </table>
                                </b-col>
                              </b-row>
                            </b-card>
                          </div>
                          
                          <!-- Legal Agreement Section -->
                          <div class="contract-section mb-4">
                            <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                              <b-icon icon="shield-check"></b-icon> LEGAL AGREEMENT
                            </h6>
                            <b-card class="border-primary">
                              <h6 class="text-white mb-3 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Agreement Terms</h6>
                              
                              <b-row class="mb-3">
                                <b-col cols="4"><strong>Acknowledgment:</strong></b-col>
                                <b-col cols="8">Both parties agree to all ownership terms and conditions</b-col>
                                <b-col cols="4"><strong>Governing Law:</strong></b-col>
                                <b-col cols="8">Laws of Ethiopia</b-col>
                                <b-col cols="4"><strong>Document Date:</strong></b-col>
                                <b-col cols="8">{{ new Date().toLocaleDateString() }}</b-col>
                              </b-row>
                              
                              <h6 class="text-white mb-3 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Signatures</h6>
                              <b-row>
                                <b-col md="6">
                                  <div class="signature-box p-3 border rounded bg-light">
                                    <p class="mb-1"><strong>Property Manager Signature:</strong></p>
                                    <div class="signature-line border-bottom mb-2" style="height: 40px;"></div>
                                    <small class="text-muted">Date: _______________</small>
                                  </div>
                                </b-col>
                                <b-col md="6">
                                  <div class="signature-box p-3 border rounded bg-light">
                                    <p class="mb-1"><strong>Property Owner Signature:</strong></p>
                                    <div class="signature-line border-bottom mb-2" style="height: 40px;"></div>
                                    <small class="text-muted">Date: _______________</small>
                                  </div>
                                </b-col>
                              </b-row>
                            </b-card>
                          </div>
                        </div>
                </div>
              </div>
            </div>
            
            <!-- Navigation Buttons -->
            <div class="modal-navigation mt-4" v-if="currentStep === 4">
              <b-row class="justify-content-between align-items-center">
                <b-col cols="auto">
                  <b-button 
                    variant="outline-secondary" 
                    @click="previousStep"
                    class="px-4"
                  >
                    <b-icon icon="chevron-left"></b-icon> Previous
                  </b-button>
                </b-col>
                <b-col cols="auto">
                  <div class="d-flex align-items-center">
                    <span class="text-muted me-2">Step {{ currentStep }} of 4</span>
                    <div class="progress" style="width: 120px; height: 6px;">
                      <div 
                        class="progress-bar" 
                        style="background-color: rgb(37, 91, 48) !important;"
                        :style="{ width: (currentStep / 4) * 100 + '%' }"
                      ></div>
                    </div>
                  </div>
                </b-col>
                <b-col cols="auto">
                  <b-button 
                    variant="success"
                    @click="submitAddForm"
                    class="px-4"
                    style="background-color: rgb(37, 91, 48) !important; border-color: rgb(37, 91, 48) !important;"
                  >
                    <b-icon icon="check-circle"></b-icon> Submit Ownership
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-modal>
      </div>
      <!-- Edit Modal -->
      <div class="row">
        <b-modal
            id="modal-edit-ownership"
            hide-footer
            title="Edit Ownership"
            content-class="shadow"
            size="lg"
          >
            <template #modal-header="{ close }">
              <h5>Edit Ownership</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="close()"
                ></b-icon>
              </p>
            </template>
            
            <div v-if="selectedOwnership.paidTotalAmount > 0" class="alert alert-warning mb-3">
              <strong>Note:</strong> Payments have started for this ownership. Owner and House fields cannot be modified.
            </div>
            
            <validation-observer ref="editObserver" v-slot="{ handleSubmit }">
              <b-form @submit.stop.prevent="handleSubmit(submitEditForm)">
                <b-row no-gutters>
                  <b-col md="6">
                    <Vselect
                      :modelValue="selectedOwnership.ownerId"
                      @update:modelValue="(newValue) => (selectedOwnership.ownerId = newValue)"
                      :options="ownerOptions"
                      :rules="selectedOwnership.paidTotalAmount > 0 ? {} : { required: true }"
                      :disabled="selectedOwnership.paidTotalAmount > 0"
                      id="edit-owner"
                      name="edit-owner"
                      label="Owner"
                      class="mb-1 mr-sm-2"
                      description="edit-owner-feedback"
                      validatorName="Owner"
                    />
                  </b-col>
                  <b-col md="6">
                    <Vselect
                      :modelValue="selectedOwnership.houseId"
                      @update:modelValue="(newValue) => (selectedOwnership.houseId = newValue)"
                      :options="editHouseOptions"
                      :rules="selectedOwnership.paidTotalAmount > 0 ? {} : { required: true }"
                      :disabled="selectedOwnership.paidTotalAmount > 0"
                      id="edit-house"
                      name="edit-house"
                      label="House"
                      class="mb-1 mr-sm-2"
                      description="edit-house-feedback"
                      validatorName="House"
                    />
                  </b-col>
                  <b-col md="6">
                    <Vinput
                      inputType="date"
                      :modelValue="selectedOwnership.startDate"
                      @update:modelValue="(newValue) => (selectedOwnership.startDate = newValue)"
                      :rules="{ required: true }"
                      id="edit-startDate"
                      name="edit-startDate"
                      label="Start Date"
                      class="mb-1 mr-sm-2"
                      description="edit-startDate-feedback"
                      validatorName="Start Date"
                    />
                  </b-col>
                  <b-col md="6">
                    <VinputNumber
                      :modelValue="selectedOwnership.repaymentAmount"
                      @update:modelValue="(newValue) => (selectedOwnership.repaymentAmount = newValue)"
                      :rules="{ required: true, min_value: 0.01, max_value: (selectedOwnership.unpaidTotalAmount || 999999) - 0.01 }"
                      id="edit-repaymentAmount"
                      name="edit-repaymentAmount"
                      label="Repayment Amount"
                      class="mb-1 mr-sm-2"
                      description="edit-repaymentAmount-feedback"
                      validatorName="Repayment Amount"
                      :step=".01"
                    />
                  </b-col>
                  <b-col md="6">
                    <Vselect
                      :modelValue="selectedOwnership.repaymentFrequency"
                      @update:modelValue="(newValue) => (selectedOwnership.repaymentFrequency = newValue)"
                      :options="frequencyOptions"
                      :rules="{ required: true }"
                      id="edit-frequency"
                      name="edit-frequency"
                      label="Repayment Frequency"
                      class="mb-1 mr-sm-2"
                      description="edit-frequency-feedback"
                      validatorName="Repayment Frequency"
                    />
                  </b-col>
                  <b-col md="6">
                    <Vinput
                      inputType="range"
                      :modelValue="selectedOwnership.gracePeriod"
                      @update:modelValue="(newValue) => (selectedOwnership.gracePeriod = newValue)"
                      id="edit-gracePeriod"
                      name="edit-gracePeriod"
                      :label="`Grace Period: ${selectedOwnership.gracePeriod || 0} days`"
                      class="mb-1 mr-sm-2"
                      description="edit-gracePeriod-feedback"
                      validatorName="Grace Period"
                      min="0"
                      max="30"
                      step="1"
                      :title="selectedOwnership.gracePeriod"
                    />
                  </b-col>
                  <b-col md="12">
                    <VinputNumber
                      :modelValue="selectedOwnership.unpaidTotalAmount"
                      @update:modelValue="(newValue) => (selectedOwnership.unpaidTotalAmount = newValue)"
                      :rules="{ required: true, min_value: (selectedOwnership.repaymentAmount || 0) + 0.01 }"
                      id="edit-unpaidAmount"
                      name="edit-unpaidAmount"
                      label="Unpaid Total Amount"
                      class="mb-1 mr-sm-2"
                      description="edit-unpaidAmount-feedback"
                      validatorName="Unpaid Total Amount"
                      :step=".01"
                    />
                  </b-col>
                  
                  <b-col md="12"><hr><h6>Penalty Settings</h6></b-col>
                  <b-col md="12">
                    <b-form-checkbox v-model="selectedOwnership.hasPenalty" @change="resetEditPenaltyData">
                      Has Penalty
                    </b-form-checkbox>
                  </b-col>
                  
                  <template v-if="selectedOwnership.hasPenalty">
                    <b-col md="6">
                      <Vselect
                        :modelValue="selectedOwnership.penaltyType"
                        @update:modelValue="(newValue) => (selectedOwnership.penaltyType = newValue)"
                        :options="penaltyTypeOptions"
                        :rules="{ required: true }"
                        id="edit-penaltyType"
                        name="edit-penaltyType"
                        label="Penalty Type"
                        class="mb-1 mr-sm-2"
                        description="edit-penaltyType-feedback"
                        validatorName="Penalty Type"
                      />
                    </b-col>
                    <b-col md="6">
                      <Vselect
                        :modelValue="selectedOwnership.penaltyBase"
                        @update:modelValue="(newValue) => (selectedOwnership.penaltyBase = newValue)"
                        :options="penaltyBaseOptions"
                        :rules="{ required: true }"
                        id="edit-penaltyBase"
                        name="edit-penaltyBase"
                        label="Penalty Base"
                        class="mb-1 mr-sm-2"
                        description="edit-penaltyBase-feedback"
                        validatorName="Penalty Base"
                      />
                    </b-col>
                    <b-col md="6">
                      <Vselect
                        :modelValue="selectedOwnership.penaltyAmount"
                        @update:modelValue="(newValue) => (selectedOwnership.penaltyAmount = newValue)"
                        :options="selectedOwnership.penaltyBase === 'Percentage' ? penaltyPercentageOptions : penaltyFixedOptions"
                        :rules="{ required: true }"
                        id="edit-penaltyAmount"
                        name="edit-penaltyAmount"
                        label="Penalty Amount"
                        class="mb-1 mr-sm-2"
                        description="edit-penaltyAmount-feedback"
                        validatorName="Penalty Amount"
                      />
                    </b-col>
                    <b-col md="6" v-if="selectedOwnership.penaltyType === 'Incremental'">
                      <Vselect
                        :modelValue="selectedOwnership.penaltyIncrementDays"
                        @update:modelValue="(newValue) => (selectedOwnership.penaltyIncrementDays = newValue)"
                        :options="penaltyIncrementDaysOptions"
                        :rules="{ required: true }"
                        id="edit-penaltyIncrementDays"
                        name="edit-penaltyIncrementDays"
                        label="Penalty Increment Days"
                        class="mb-1 mr-sm-2"
                        description="edit-penaltyIncrementDays-feedback"
                        validatorName="Penalty Increment Days"
                      />
                    </b-col>
                  </template>
                  
                  <b-col md="12">
                    <Vinput
                      inputType="textarea"
                      :modelValue="selectedOwnership.description"
                      @update:modelValue="(newValue) => (selectedOwnership.description = newValue)"
                      id="edit-description"
                      name="edit-description"
                      label="Description"
                      class="mb-1 mr-sm-2"
                      description="edit-description-feedback"
                      validatorName="Description"
                    />
                  </b-col>
                  
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Update</b-button>
                    <b-button @click="submitEditForm" variant="secondary" class="ml-2">Update Change</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  import Vinput from 'src/components/Inputs/Vinput.vue'
  import VinputGroup from 'src/components/Inputs/VinputGroup.vue'
  import VinputNumber from 'src/components/Inputs/VinputNumber.vue'
  import Vselect from 'src/components/Inputs/Vselect.vue'
  export default {
    components: {
      Card,
      Vinput,
      VinputGroup,
      VinputNumber,
      Vselect
    },
    data () {
      return {
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        totalRows: 0,
        currentPage: 1,
        perPage: 7,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        items: [],
        filter: "",
        currentStep: 1,
        selectedOwnership: {
          houseOwnerId: null,
          ownerId: null,
          houseId: null,
          startDate: '',
          repaymentAmount: 0,
          repaymentFrequency: '',
          gracePeriod: 0,
          unpaidTotalAmount: 0,
          hasPenalty: false,
          penaltyType: '',
          penaltyBase: '',
          penaltyAmount: 0,
          penaltyIncrementDays: 0,
          description: '',
          paidTotalAmount: 0
        },
        addData: {
          ownerId: null,
          houseId: null,
          startDate: "",
          paymentDate: "",
          endDate: "",
          repaymentAmount: 0,
          repaymentFrequency: "",
          gracePeriod: 0,
          unpaidTotalAmount: 0,
          hasPenalty: false,
          penaltyType: "",
          penaltyBase: "",
          penaltyAmount: 0,
          penaltyIncrementDays: 0,
          customPenaltyAmount: 0,
          customPenaltyIncrementDays: 0,
          description: "",
          userId: parseInt(sessionStorage.getItem("ID")),
          registeredById: parseInt(sessionStorage.getItem("userID"))
        },
        ownerType: 'existing',
        houseType: 'existing',
        newOwner: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: '',
          address: '',
          sex: '',
          status: ''
        },
        newHouse: {
          buildingId: null,
          roomNumber: null,
          floor: null,
          size: null
        },
        ownerTypeOptions: [
          { text: 'Existing Owner', value: 'existing' },
          { text: 'New Owner', value: 'new' }
        ],
        houseTypeOptions: [
          { text: 'Existing House', value: 'existing' },
          { text: 'New House', value: 'new' }
        ],
        ownerOptions: [],
        houseOptions: [],
        buildingOptions: [],
        frequencyOptions: [
          {text: "Daily", value: "Daily"},
          {text: "Weekly", value: "Weekly"},
          {text: "Monthly", value: "Monthly"},
          {text: "Quarterly", value: "Quarterly"},
          {text: "Semi-Annual", value: "Semi-Annual"},
          {text: "Annual", value: "Annual"}
        ],
        sexOptions: [
          {text: "Male", value: "Male"},
          {text: "Female", value: "Female"}
        ],
        statusOptions: [
          {text: "Active", value: "Active"},
          {text: "Inactive", value: "Inactive"}
        ],
        penaltyTypeOptions: [
          {text: "Fixed", value: "Fixed"},
          {text: "Incremental", value: "Incremental"}
        ],
        penaltyBaseOptions: [
          {text: "Percentage", value: "Percentage"},
          {text: "Fixed", value: "Fixed"}
        ],
        penaltyIncrementDaysOptions: [
          {text: "1 Day", value: 1},
          {text: "3 Days", value: 3},
          {text: "5 Days", value: 5},
          {text: "7 Days", value: 7},
          {text: "10 Days", value: 10},
          {text: "15 Days", value: 15},
          {text: "30 Days", value: 30},
          {text: "Other", value: "Other"}
        ],
        penaltyPercentageOptions: [
          {text: "1%", value: 1},
          {text: "2%", value: 2},
          {text: "5%", value: 5},
          {text: "10%", value: 10},
          {text: "15%", value: 15},
          {text: "20%", value: 20},
          {text: "Other", value: "Other"}
        ],
        penaltyFixedOptions: [
          {text: "100 ETB", value: 100},
          {text: "200 ETB", value: 200},
          {text: "500 ETB", value: 500},
          {text: "1000 ETB", value: 1000},
          {text: "2000 ETB", value: 2000},
          {text: "5000 ETB", value: 5000},
          {text: "Other", value: "Other"}
        ],
        editHouseOptions: [],
        spinner: true
      }
    },
    computed: {
      canProceedToNext() {
        switch (this.currentStep) {
          case 1:
            if (this.ownerType === 'existing') {
              return this.addData.ownerId !== null;
            } else {
              return this.newOwner.firstName && this.newOwner.lastName && this.newOwner.phoneNumber && this.newOwner.address;
            }
          case 2:
            if (this.houseType === 'existing') {
              return this.addData.houseId !== null;
            } else {
              return this.newHouse.buildingId && this.newHouse.roomNumber && this.newHouse.floor;
            }
          case 3:
            return this.addData.startDate && this.addData.repaymentAmount > 0 && this.addData.repaymentFrequency && this.addData.unpaidTotalAmount > 0 && this.addData.repaymentAmount < this.addData.unpaidTotalAmount;
          default:
            return true;
        }
      },
      filterTable() {
        var searchItems = this.items;
        var searchString = this.filter;
        if (searchString === "") {
          return searchItems;
        }
        searchString = searchString.trim().toLowerCase();

        searchItems = searchItems.filter(function (item) {
          if (item.owner.fullName.toLowerCase().indexOf(searchString) !== -1 || 
              item.house.building.buildingName.toLowerCase().indexOf(searchString) !== -1 ||
              item.house.roomNumber.toLowerCase().indexOf(searchString) !== -1) {
            return item;
          }
        });
        return searchItems;
      },
    },
     mounted() {
      this.getModules();
      this.getOwnershipList();
      this.loadOwners();
      this.loadHouses();
      this.loadBuildings();
      this.$on("AfterComplete", () => {
        this.getOwnershipList();
      });
    },
    methods: {
      getModules(){
        this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(response=>{
              var modulesList = response.data.modules;
              var OwnershipModule = modulesList.filter(x=>x.name === "Ownership");
              if(OwnershipModule !== null && OwnershipModule.length > 0){
                this.modulePermission.view = OwnershipModule[0].listData;
                this.modulePermission.create = OwnershipModule[0].createData;
                this.modulePermission.update = OwnershipModule[0].updateData;
                this.modulePermission.delete = OwnershipModule[0].deleteData;
              }
          })
          .catch(error=>{
              console.log(error);
          })
      },
      getOwnershipList(){
          this.$store.dispatch('listOwnerAndHouseInfoByUser', {
            userId: parseInt(sessionStorage.getItem("ID")), 
            page: this.currentPage - 1, 
            line: this.perPage,
            createdDate: null,
            paymentStatus: null
          })
          .then(response=>{
              this.items = response.data.content;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              console.log(error);
          })
          .finally(msg=>{
            this.spinner = false;
          })
      },
      loadOwners(){
        this.$store.dispatch('getOwnersByUser',{userId: sessionStorage.getItem("ID")})
        .then(response=>{
          this.owners = response.data;
            Array.from(response.data).forEach((value) => {
            this.ownerOptions.push({
              value: value.id,
              text: value.fullName,
            });
          });
        })
        .catch(error=>{
            this.$notify({
                title: 'Error',
                text: error.response.data,
                type: 'error'
            })
        })
      },
      loadHouses(){
       this.$store.dispatch('getFreeOwnershipByOwnerID',{userId: sessionStorage.getItem("ID")})
        .then(response=>{
          this.houses = response.data;
            Array.from(response.data).forEach((value) => {
            this.houseOptions.push({
              value: value.houseId,
              text: value.building.buildingName+"-"+value.floor+"-"+value.roomNumber,
              size: value.size,
            });
          });
        })
        .catch(error=>{
            this.$notify({
                title: 'Error',
                text: error.response.data,
                type: 'error'
            })
        })
      },
      loadBuildings(){
       this.$store.dispatch('getBuildingsByOwnerID',{userId: sessionStorage.getItem("ID")})
        .then(response=>{
          // console.log("building", response.data);
            Array.from(response.data).forEach((value) => {
            this.buildingOptions.push({
              value: value.buildingId,
              text: value.buildingName,
            });
          });
        })
        .catch(error=>{
            this.$notify({
                title: 'Error',
                text: error.response.data,
                type: 'error'
            })
        })
      },
      resetOwnerData(){
        this.addData.ownerId = null;
        this.newOwner = {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: '',
          address: '',
          sex: '',
          status: ''
        };
      },
      resetHouseData(){
        this.addData.houseId = null;
        this.newHouse = {
          buildingId: null,
          roomNumber: null,
          floor: null,
          size: null
        };
      },
      resetPenaltyData(){
        if (!this.addData.hasPenalty) {
          this.addData.penaltyType = "";
          this.addData.penaltyBase = "";
          this.addData.penaltyAmount = 0;
          this.addData.penaltyIncrementDays = 0;
        }
      },
      resetEditPenaltyData(){
        if (!this.selectedOwnership.hasPenalty) {
          this.selectedOwnership.penaltyType = "";
          this.selectedOwnership.penaltyBase = "";
          this.selectedOwnership.penaltyAmount = 0;
          this.selectedOwnership.penaltyIncrementDays = 0;
        }
      },
      changePage(event, page){
        this.spinner = true;
        this.$store.dispatch('listOwnerAndHouseInfoByUser', {
          userId: parseInt(sessionStorage.getItem("ID")), 
          page: page - 1, 
          line: this.perPage,
          createdDate: null,
          paymentStatus: null
        })
          .then(response=>{
              this.items = response.data.content;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              console.log(error);
          })
          .finally(msg=>{
            this.spinner = false;
          })
      },
      changePerPage(event){
        this.spinner = true;
        this.$store.dispatch('listOwnerAndHouseInfoByUser', {
          userId: parseInt(sessionStorage.getItem("ID")), 
          page: this.currentPage - 1, 
          line: this.perPage,
          createdDate: null,
          paymentStatus: null
        })
          .then(response=>{
              this.items = response.data.content;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              console.log(error);
          })
          .finally(msg=>{
            this.spinner = false;
          })
      },
      AddOwnership(){
        this.currentStep = 1;
        this.$bvModal.show('modal-center-add');
      },
      EditOwnership(ID){
        const ownership = this.items.find(item => item.id === ID);
        if (ownership) {
          this.selectedOwnership = {
            houseOwnerId: ownership.id,
            ownerId: ownership.owner.id,
            houseId: ownership.house.id,
            startDate: ownership.startDate,
            repaymentAmount: ownership.repaymentAmount,
            repaymentFrequency: ownership.repaymentFrequency,
            gracePeriod: ownership.gracePeriod,
            unpaidTotalAmount: ownership.unpaidTotalAmount,
            hasPenalty: ownership.hasPenalty,
            penaltyType: ownership.penaltyType,
            penaltyBase: ownership.penaltyBase,
            penaltyAmount: ownership.penaltyAmount,
            penaltyIncrementDays: ownership.penaltyIncrementDays,
            description: ownership.description,
            paidTotalAmount: ownership.paidTotalAmount || 0
          };
          this.loadHousesForEdit(ownership.house);
          this.$bvModal.show('modal-edit-ownership');
        }
      },
      loadHousesForEdit(currentHouse) {
        // Initialize with current house immediately
        this.editHouseOptions = [];
        const buildingName = currentHouse.building ? (currentHouse.building.buildingName || currentHouse.building.name || 'Unknown Building') : 'Unknown Building';
        this.editHouseOptions.push({
          value: currentHouse.id,
          text: `${buildingName}-${currentHouse.floor}-${currentHouse.roomNumber} (Current)`,
          size: currentHouse.size
        });
        
        // Then load free houses
        this.$store.dispatch('getFreeOwnershipByOwnerID', {userId: sessionStorage.getItem("ID")})
        .then(response => {
          // Add free houses (exclude current house if it appears in free houses)
          Array.from(response.data).forEach((house) => {
            if (house.houseId !== currentHouse.houseId) {
              this.editHouseOptions.push({
                value: house.houseId,
                text: `${house.building.buildingName}-${house.floor}-${house.roomNumber}`,
                size: house.size
              });
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
      },
      nextStep() {
        // Custom validation for step 3
        if (this.currentStep === 3) {
          if (this.addData.repaymentAmount > this.addData.unpaidTotalAmount) {
            this.$notifications.notify({
              message: 'Repayment Amount must be less than Unpaid Total Amount',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
            return;
          }
        }
        this.currentStep++;
      },
      previousStep() {
        if (this.currentStep > 1) {
          this.currentStep--;
        }
      },
      getOwnerName(ownerId) {
        const owner = this.ownerOptions.find(o => o.value === ownerId);
        return owner ? owner.text : 'Unknown Owner';
      },
      getHouseName(houseId) {
        const house = this.houseOptions.find(h => h.value === houseId);
        return house ? house.text : 'Unknown House';
      },
      getBuildingName(buildingId) {
        const building = this.buildingOptions.find(b => b.value === buildingId);
        return building ? building.text : 'Unknown Building';
      },
      formatDate(dateString) {
        if (!dateString) return 'Not specified';
        return new Date(dateString).toLocaleDateString('en-US', { 
          weekday: 'long', 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        });
      },
      getPaymentDescription(frequency) {
        const descriptions = {
          'Daily': 'payment due every day',
          'Weekly': 'payment due every week',
          'Monthly': 'payment due every month',
          'Quarterly': 'payment due every 3 months',
          'Semi-Annual': 'payment due every 6 months',
          'Annual': 'payment due every year'
        };
        return descriptions[frequency] || 'custom payment schedule';
      },
      getFloorSuffix(floor) {
        if (floor == 1) return 'st';
        if (floor == 2) return 'nd';
        if (floor == 3) return 'rd';
        return 'th';
      },
      printOwnership() {
        this.generatePrintContent();
      },
      
      generatePrintContent() {
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
          <html>
            <head>
              <title>Property Ownership Agreement</title>
              <style>
                body { font-family: 'Times New Roman', serif; margin: 25px; line-height: 1.5; color: #333; font-size: 12px; }
                .header { text-align: center; margin-bottom: 25px; border-bottom: 3px solid #000; padding-bottom: 15px; }
                .section { margin: 20px 0; page-break-inside: avoid; }
                .section-title { font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff; }
                table { width: 100%; border-collapse: collapse; margin: 10px 0; }
                td { padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; }
                .label { font-weight: bold; width: 35%; background-color: #f8f9fa; }
                .signature-box { display: inline-block; width: 45%; margin: 15px 2%; vertical-align: top; }
                .signature-line { border-bottom: 2px solid #000; height: 40px; margin: 12px 0; }
                .important { background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 10px; margin: 10px 0; }
              </style>
            </head>
            <body>
              <div class="header">
                <h1>PROPERTY OWNERSHIP AGREEMENT</h1>
                <p>This agreement establishes ownership terms, payment schedule, and penalty conditions for the specified property.</p>
              </div>
              
              <div class="section">
                <div class="section-title">1. PARTIES TO THE AGREEMENT</div>
                <table>
                  <tr><td class="label">Property Manager</td><td>${this.getCurrentUserName()}</td></tr>
                  <tr><td class="label">Property Owner</td><td>${this.ownerType === 'existing' ? this.getOwnerName(this.addData.ownerId) : this.newOwner.firstName + ' ' + this.newOwner.lastName}</td></tr>
                </table>
              </div>
              
              <div class="section">
                <div class="section-title">2. PROPERTY DETAILS</div>
                ${this.houseType === 'existing' ? `
                <table>
                  <tr><td class="label">Property</td><td>${this.getHouseName(this.addData.houseId)}</td></tr>
                </table>` : `
                <table>
                  <tr><td class="label">Building</td><td>${this.getBuildingName(this.newHouse.buildingId)}</td></tr>
                  <tr><td class="label">Floor</td><td>${this.newHouse.floor}${this.getFloorSuffix(this.newHouse.floor)} Floor</td></tr>
                  <tr><td class="label">Room</td><td>${this.newHouse.roomNumber}</td></tr>
                  <tr><td class="label">Size</td><td>${this.newHouse.size} sq.ft</td></tr>
                </table>`}
              </div>
              
              <div class="section">
                <div class="section-title">3. OWNERSHIP TERMS</div>
                <table>
                  <tr><td class="label">Start Date</td><td>${this.addData.startDate}</td></tr>
                  <tr><td class="label">Payment Frequency</td><td>${this.addData.repaymentFrequency}</td></tr>
                  <tr><td class="label">Payment Amount</td><td>${this.numberWithCommas(this.addData.repaymentAmount)} ETB</td></tr>
                  <tr><td class="label">Grace Period</td><td>${this.addData.gracePeriod} days</td></tr>
                  <tr><td class="label">Total Outstanding</td><td>${this.numberWithCommas(this.addData.unpaidTotalAmount)} ETB</td></tr>
                  <tr><td class="label">Penalty</td><td>${this.addData.hasPenalty ? 'Enabled' : 'Disabled'}</td></tr>
                </table>
              </div>
              
              <div class="section">
                <div class="section-title">4. PAYMENT METHOD AND BANKING INFORMATION</div>
                <div class="important">
                  <strong>Payment Method:</strong> All ownership payments must be made through Tsehay Bank using any of the following convenient channels:
                </div>
                <table>
                  <tr><td class="label">Mobile Banking</td><td>Use Tsehay Bank mobile app for instant payments</td></tr>
                  <tr><td class="label">Internet Banking</td><td>Access online banking portal for secure transactions</td></tr>
                  <tr><td class="label">USSD Banking</td><td>Dial USSD code for quick mobile payments</td></tr>
                  <tr><td class="label">Branch Services</td><td>Visit any Tsehay Bank branch for in-person payments</td></tr>
                  <tr><td class="label">ATM Services</td><td>Use Tsehay Bank ATMs for payment transactions</td></tr>
                  <tr><td class="label">Payment Reference</td><td>A unique payment ID will be provided after agreement establishment</td></tr>
                </table>
              </div>
              
              <div class="signature-section">
                <div class="section-title">5. SIGNATURES</div>
                <div class="signature-box">
                  <p><strong>PROPERTY MANAGER:</strong></p>
                  <div class="signature-line"></div>
                  <p>Name: ${this.getCurrentUserName()}</p>
                  <p>Date: _______________</p>
                </div>
                <div class="signature-box">
                  <p><strong>PROPERTY OWNER:</strong></p>
                  <div class="signature-line"></div>
                  <p>Name: ${this.ownerType === 'existing' ? this.getOwnerName(this.addData.ownerId) : this.newOwner.firstName + ' ' + this.newOwner.lastName}</p>
                  <p>Date: _______________</p>
                </div>
              </div>
            </body>
          </html>
        `);
        printWindow.document.close();
        
        // Wait for content to load then show print dialog
        printWindow.onload = function() {
          printWindow.print();
          printWindow.onafterprint = function() {
            printWindow.close();
          };
        };
      },
      
      async downloadOwnership() {
        try {
          const offlinePackageLoader = (await import('@/utils/offlinePackages.js')).default;
          const loaded = await offlinePackageLoader.loadOwnershipPackages();
          if (loaded && offlinePackageLoader.isHtml2PdfAvailable()) {
            this.generatePrintStylePDF();
          } else {
            this.$notifications.notify({
              message: 'PDF generation is not available. The html2pdf.js library is not properly loaded. Please contact your system administrator.',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'warning'
            });
            // Fallback: offer to print instead
            const printFallback = await this.$bvModal.msgBoxConfirm(
              'PDF download is not available. Would you like to print the ownership agreement instead?',
              {
                title: 'PDF Not Available',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                cancelVariant: 'secondary',
                okTitle: 'Print',
                cancelTitle: 'Cancel'
              }
            );
            if (printFallback) {
              this.printOwnership();
            }
          }
        } catch (error) {
          console.error('Error loading offline packages:', error);
          this.$notifications.notify({
            message: 'Error loading PDF generation library. Please try again or contact support.',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        }
      },
      
      generatePrintStylePDF() {
        // Create temporary div with print content
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = `
          <div style="font-family: 'Times New Roman', serif; margin: 25px; line-height: 1.5; color: #333; font-size: 12px;">
            <div style="text-align: center; margin-bottom: 25px; border-bottom: 3px solid #000; padding-bottom: 15px;">
              <h1>PROPERTY OWNERSHIP AGREEMENT</h1>
              <p>This agreement establishes ownership terms, payment schedule, and penalty conditions for the specified property.</p>
            </div>
            
            <div style="margin: 20px 0; page-break-inside: avoid;">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff;">1. PARTIES TO THE AGREEMENT</div>
              <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Property Manager</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.getCurrentUserName()}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Property Owner</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.ownerType === 'existing' ? this.getOwnerName(this.addData.ownerId) : this.newOwner.firstName + ' ' + this.newOwner.lastName}</td></tr>
              </table>
            </div>
            
            <div style="margin: 20px 0; page-break-inside: avoid;">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff;">2. PROPERTY DETAILS</div>
              ${this.houseType === 'existing' ? `
              <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Property</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.getHouseName(this.addData.houseId)}</td></tr>
              </table>` : `
              <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Building</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.getBuildingName(this.newHouse.buildingId)}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Floor</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.newHouse.floor}${this.getFloorSuffix(this.newHouse.floor)} Floor</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Room</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.newHouse.roomNumber}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Size</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.newHouse.size} sq.ft</td></tr>
              </table>`}
            </div>
            
            <div style="margin: 20px 0; page-break-inside: avoid;">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff;">3. OWNERSHIP TERMS</div>
              <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Start Date</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.addData.startDate}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Payment Frequency</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.addData.repaymentFrequency}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Payment Amount</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.numberWithCommas(this.addData.repaymentAmount)} ETB</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Grace Period</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.addData.gracePeriod} days</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Total Outstanding</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.numberWithCommas(this.addData.unpaidTotalAmount)} ETB</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Penalty</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">${this.addData.hasPenalty ? 'Enabled' : 'Disabled'}</td></tr>
              </table>
            </div>
            
            <div style="margin: 20px 0; page-break-inside: avoid;">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff;">4. PAYMENT METHOD AND BANKING INFORMATION</div>
              <div style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 10px; margin: 10px 0;">
                <strong>Payment Method:</strong> All ownership payments must be made through Tsehay Bank using any of the following convenient channels:
              </div>
              <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Mobile Banking</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">Use Tsehay Bank mobile app for instant payments</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Internet Banking</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">Access online banking portal for secure transactions</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">USSD Banking</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">Dial USSD code for quick mobile payments</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Branch Services</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">Visit any Tsehay Bank branch for in-person payments</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">ATM Services</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">Use Tsehay Bank ATMs for payment transactions</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; font-weight: bold; width: 35%; background-color: #f8f9fa;">Payment Reference</td><td style="padding: 6px 10px; border: 1px solid #ddd; vertical-align: top;">A unique payment ID will be provided after agreement establishment</td></tr>
              </table>
            </div>
            
            <div style="margin: 20px 0; page-break-inside: avoid;">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff;">5. SIGNATURES</div>
              <div style="display: inline-block; width: 45%; margin: 15px 2%; vertical-align: top;">
                <p><strong>PROPERTY MANAGER:</strong></p>
                <div style="border-bottom: 2px solid #000; height: 40px; margin: 12px 0;"></div>
                <p>Name: ${this.getCurrentUserName()}</p>
                <p>Date: _______________</p>
              </div>
              <div style="display: inline-block; width: 45%; margin: 15px 2%; vertical-align: top;">
                <p><strong>PROPERTY OWNER:</strong></p>
                <div style="border-bottom: 2px solid #000; height: 40px; margin: 12px 0;"></div>
                <p>Name: ${this.ownerType === 'existing' ? this.getOwnerName(this.addData.ownerId) : this.newOwner.firstName + ' ' + this.newOwner.lastName}</p>
                <p>Date: _______________</p>
              </div>
            </div>
          </div>
        `;
        
        document.body.appendChild(tempDiv);
        
        const opt = {
          margin: 0.5,
          filename: `Property_Ownership_Agreement_${this.addData.startDate || new Date().toISOString().split('T')[0]}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        };
        
        html2pdf().set(opt).from(tempDiv).save().then(() => {
          document.body.removeChild(tempDiv);
        });
      },
      
      generateOwnershipPDF() {
        const element = document.getElementById('pdf-content');
        
        const opt = {
          margin: 0.5,
          filename: `Property_Ownership_Agreement_${this.addData.startDate || new Date().toISOString().split('T')[0]}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        };
        
        html2pdf().set(opt).from(element).save();
      },
      // Overview logic methods similar to Contracts component
      getOwnerOverview() {
        if (this.ownerType === 'existing') {
          return {
            type: 'Existing Owner (Selected from database)',
            name: this.getOwnerName(this.addData.ownerId),
            description: 'This owner is already registered in the system with verified credentials.'
          };
        } else {
          return {
            type: 'New Owner (First-time registration)',
            name: `${this.newOwner.firstName} ${this.newOwner.lastName}`,
            phone: `+251${this.newOwner.phoneNumber}`,
            email: this.newOwner.email || 'Not provided',
            address: this.newOwner.address,
            gender: this.newOwner.sex,
            status: this.newOwner.status,
            description: 'New owner being registered for the first time'
          };
        }
      },
      
      getPropertyOverview() {
        if (this.houseType === 'existing') {
          const house = this.houseOptions.find(h => h.value === this.addData.houseId);
          return {
            type: 'Existing Property (Available in inventory)',
            name: this.getHouseName(this.addData.houseId),
            size: house ? `${house.size} square feet` : 'Size not available',
            description: 'This property is available and ready for ownership transfer.'
          };
        } else {
          return {
            type: 'New Property (First-time registration)',
            building: this.getBuildingName(this.newHouse.buildingId),
            room: `Room ${this.newHouse.roomNumber}`,
            floor: `${this.newHouse.floor}${this.getFloorSuffix(this.newHouse.floor)} Floor`,
            size: `${this.newHouse.size} square feet`,
            description: 'New property being registered for the first time'
          };
        }
      },
      
      getFinancialOverview() {
        return {
          startDate: this.formatDate(this.addData.startDate),
          repaymentAmount: `${this.addData.repaymentAmount} ETB`,
          frequency: this.addData.repaymentFrequency,
          frequencyDescription: this.getPaymentDescription(this.addData.repaymentFrequency),
          gracePeriod: `${this.addData.gracePeriod} days`,
          gracePeriodDescription: this.addData.gracePeriod > 0 
            ? 'Additional time allowed after due date before penalties apply' 
            : 'No grace period - penalties apply immediately after due date',
          unpaidTotal: `${this.addData.unpaidTotalAmount} ETB`,
          unpaidDescription: 'Total amount remaining to be paid for full ownership'
        };
      },
      
      getPenaltyOverview() {
        if (!this.addData.hasPenalty) {
          return {
            enabled: false,
            description: 'No penalties for late payments',
            details: 'This is a penalty-free agreement'
          };
        }
        
        const penaltyAmount = this.addData.penaltyAmount === 'Other' 
          ? this.addData.customPenaltyAmount 
          : this.addData.penaltyAmount;
        
        const penaltySuffix = this.addData.penaltyBase === 'Percentage' ? '%' : ' ETB';
        
        let description = `${this.addData.penaltyType} penalty system with ${this.addData.penaltyBase.toLowerCase()}-based calculation. `;
        description += `Rate: ${penaltyAmount}${penaltySuffix}. `;
        
        if (this.addData.penaltyType === 'Incremental') {
          const incrementDays = this.addData.penaltyIncrementDays === 'Other' 
            ? this.addData.customPenaltyIncrementDays 
            : this.addData.penaltyIncrementDays;
          description += `Penalty increases every ${incrementDays} days of continued non-payment.`;
        } else {
          description += 'Same penalty amount for each late payment occurrence.';
        }
        
        return {
          enabled: true,
          type: this.addData.penaltyType,
          typeDescription: this.addData.penaltyType === 'Fixed' 
            ? 'Same penalty amount for each late payment' 
            : 'Penalty increases with longer delays',
          base: this.addData.penaltyBase,
          baseDescription: this.addData.penaltyBase === 'Percentage' 
            ? 'Penalty calculated as percentage of outstanding amount' 
            : 'Fixed penalty amount regardless of outstanding balance',
          amount: `${penaltyAmount}${penaltySuffix}`,
          incrementDays: this.addData.penaltyType === 'Incremental' 
            ? (this.addData.penaltyIncrementDays === 'Other' 
                ? this.addData.customPenaltyIncrementDays 
                : this.addData.penaltyIncrementDays) 
            : null,
          description: description
        };
      },
      
      getDocumentOverview() {
        return {
          generated: new Date().toLocaleDateString('en-US', { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          }),
          time: new Date().toLocaleTimeString(),
          reference: `OWN-${Date.now()}`,
          description: this.addData.description || 'No additional notes provided.'
        };
      },
      
      getCurrentUserName() {
        return sessionStorage.getItem('userName') || 'Property Manager';
      },
      
      numberWithCommas(x) {
        if (x === null || x === undefined || x === '') return '0';
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      
      getPenaltyDescription() {
        if (!this.addData.hasPenalty) {
          return 'No penalty system applied';
        }
        
        const penaltyAmount = this.addData.penaltyAmount === 'Other' 
          ? this.addData.customPenaltyAmount 
          : this.addData.penaltyAmount;
        
        const penaltySuffix = this.addData.penaltyBase === 'Percentage' ? '%' : ' ETB';
        
        let description = `${this.addData.penaltyType} penalty system: ${penaltyAmount}${penaltySuffix} `;
        description += this.addData.penaltyBase === 'Percentage' 
          ? 'of outstanding amount ' 
          : 'fixed amount ';
        description += 'charged for late payments';
        
        if (this.addData.penaltyType === 'Incremental') {
          const incrementDays = this.addData.penaltyIncrementDays === 'Other' 
            ? this.addData.customPenaltyIncrementDays 
            : this.addData.penaltyIncrementDays;
          description += `. Penalty increases every ${incrementDays} days of continued non-payment`;
        }
        
        return description;
      },
      
      // Additional helper methods for comprehensive overview
      getOwnershipSummary() {
        return {
          owner: this.getOwnerOverview(),
          property: this.getPropertyOverview(),
          financial: this.getFinancialOverview(),
          penalty: this.getPenaltyOverview(),
          document: this.getDocumentOverview()
        };
      },
      
      validateOwnershipData() {
        const errors = [];
        
        // Owner validation
        if (this.ownerType === 'existing' && !this.addData.ownerId) {
          errors.push('Owner selection is required');
        } else if (this.ownerType === 'new') {
          if (!this.newOwner.firstName || !this.newOwner.lastName) {
            errors.push('Owner name is required');
          }
          if (!this.newOwner.phoneNumber) {
            errors.push('Owner phone number is required');
          }
        }
        
        // Property validation
        if (this.houseType === 'existing' && !this.addData.houseId) {
          errors.push('Property selection is required');
        } else if (this.houseType === 'new') {
          if (!this.newHouse.buildingId || !this.newHouse.roomNumber || !this.newHouse.floor) {
            errors.push('Complete property information is required');
          }
        }
        
        // Financial validation
        if (!this.addData.startDate) {
          errors.push('Start date is required');
        }
        if (!this.addData.repaymentAmount || this.addData.repaymentAmount <= 0) {
          errors.push('Valid repayment amount is required');
        }
        if (!this.addData.repaymentFrequency) {
          errors.push('Repayment frequency is required');
        }
        if (!this.addData.unpaidTotalAmount || this.addData.unpaidTotalAmount <= 0) {
          errors.push('Valid unpaid total amount is required');
        }
        if (this.addData.repaymentAmount >= this.addData.unpaidTotalAmount) {
          errors.push('Repayment amount must be less than unpaid total amount');
        }
        
        // Penalty validation
        if (this.addData.hasPenalty) {
          if (!this.addData.penaltyType || !this.addData.penaltyBase) {
            errors.push('Complete penalty information is required when penalties are enabled');
          }
          if (!this.addData.penaltyAmount || this.addData.penaltyAmount === 0) {
            errors.push('Penalty amount is required when penalties are enabled');
          }
          if (this.addData.penaltyAmount === 'Other' && (!this.addData.customPenaltyAmount || this.addData.customPenaltyAmount <= 0)) {
            errors.push('Custom penalty amount is required');
          }
          if (this.addData.penaltyType === 'Incremental' && !this.addData.penaltyIncrementDays) {
            errors.push('Penalty increment days are required for incremental penalties');
          }
          if (this.addData.penaltyType === 'Incremental' && this.addData.penaltyIncrementDays === 'Other' && (!this.addData.customPenaltyIncrementDays || this.addData.customPenaltyIncrementDays <= 0)) {
            errors.push('Custom penalty increment days are required');
          }
        }
        
        return errors;
      },
      
      getOwnershipStatus() {
        const validation = this.validateOwnershipData();
        return {
          isValid: validation.length === 0,
          errors: validation,
          completionPercentage: this.calculateCompletionPercentage()
        };
      },
      
      calculateCompletionPercentage() {
        let completed = 0;
        let total = 10; // Total number of required fields/sections
        
        // Owner information (2 points)
        if (this.ownerType === 'existing' && this.addData.ownerId) completed += 2;
        else if (this.ownerType === 'new' && this.newOwner.firstName && this.newOwner.lastName && this.newOwner.phoneNumber) completed += 2;
        
        // Property information (2 points)
        if (this.houseType === 'existing' && this.addData.houseId) completed += 2;
        else if (this.houseType === 'new' && this.newHouse.buildingId && this.newHouse.roomNumber && this.newHouse.floor) completed += 2;
        
        // Financial information (4 points)
        if (this.addData.startDate) completed += 1;
        if (this.addData.repaymentAmount > 0) completed += 1;
        if (this.addData.repaymentFrequency) completed += 1;
        if (this.addData.unpaidTotalAmount > 0) completed += 1;
        
        // Penalty information (2 points)
        if (!this.addData.hasPenalty) completed += 2;
        else if (this.addData.penaltyType && this.addData.penaltyBase && this.addData.penaltyAmount) completed += 2;
        
        return Math.round((completed / total) * 100);
      },
      
      downloadAsTextBackup() {
        const ownerOverview = this.getOwnerOverview();
        const propertyOverview = this.getPropertyOverview();
        const financialOverview = this.getFinancialOverview();
        const penaltyOverview = this.getPenaltyOverview();
        const documentOverview = this.getDocumentOverview();
        
        const ownerInfo = this.ownerType === 'existing' 
          ? `Selected Owner: ${ownerOverview.name}\n   ${ownerOverview.description}`
          : `New Owner Registration:\n   Full Name: ${ownerOverview.name}\n   Phone: ${ownerOverview.phone}\n   Email: ${ownerOverview.email}\n   Address: ${ownerOverview.address}\n   Gender: ${ownerOverview.gender}\n   Status: ${ownerOverview.status}`;
        
        const houseInfo = this.houseType === 'existing'
          ? `Selected Property: ${propertyOverview.name}\n   Size: ${propertyOverview.size}\n   ${propertyOverview.description}`
          : `New Property Registration:\n   Building: ${propertyOverview.building}\n   Room: ${propertyOverview.room}\n   Floor: ${propertyOverview.floor}\n   Size: ${propertyOverview.size}`;
        
        const penaltyInfo = penaltyOverview.enabled
          ? `Penalty System: ENABLED\n   ${penaltyOverview.description}`
          : `Penalty System: DISABLED\n   ${penaltyOverview.details}`;
        
        const content = `
═══════════════════════════════════════════════════════════════
                    PROPERTY OWNERSHIP AGREEMENT
                Complete Ownership Information Summary
═══════════════════════════════════════════════════════════════

DOCUMENT OVERVIEW:
This document contains the complete ownership information for property 
registration. This agreement establishes the ownership terms, payment 
schedule, and penalty conditions for the specified property.

👤 OWNER INFORMATION:
${ownerInfo}

🏠 PROPERTY INFORMATION:
${houseInfo}

💰 FINANCIAL TERMS:
Ownership Start Date: ${financialOverview.startDate}
Regular Payment Amount: ${financialOverview.repaymentAmount} (${financialOverview.frequencyDescription})
Payment Schedule: ${financialOverview.frequency}
Grace Period: ${financialOverview.gracePeriod} (${financialOverview.gracePeriodDescription})
Total Outstanding Amount: ${financialOverview.unpaidTotal}

⚠️ PENALTY CONDITIONS:
${penaltyInfo}

ADDITIONAL NOTES:
${documentOverview.description}

═══════════════════════════════════════════════════════════════
DOCUMENT INFORMATION:
Generated: ${documentOverview.generated} at ${documentOverview.time}
System Reference: ${documentOverview.reference}

DISCLAIMER:
This document serves as a comprehensive summary of the ownership 
agreement. All terms and conditions are subject to the organization's 
policies and applicable laws.
═══════════════════════════════════════════════════════════════
        `;
        
        const element = document.createElement('a');
        const file = new Blob([content], { type: 'text/plain' });
        element.href = URL.createObjectURL(file);
        element.download = `ownership_agreement_${Date.now()}.txt`;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      },
      async submitAddForm(){
        // Validate data before submission
        const status = this.getOwnershipStatus();
        if (!status.isValid) {
          this.$notifications.notify({
            message: `Please fix the following errors: ${status.errors.join(', ')}`,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
          return;
        }
        
        const confirmed = await this.$bvModal.msgBoxConfirm('Are you sure you want to submit this ownership agreement?', {
          title: 'Confirm Ownership Submission',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          cancelVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          bodyClass: 'm-2',
          hideHeaderClose: false,
          centered: false
        });
        
        if (!confirmed) return;
        
        try {
          let ownerId = this.addData.ownerId;
          let houseId = this.addData.houseId;
          
          // Prepare ownership data with all fields
          const ownershipData = {
            ...this.addData,
            ownerId,
            houseId,
            // Add new owner fields if creating new owner
            ...(this.ownerType === 'new' && {
              fullName: `${this.newOwner.firstName} ${this.newOwner.lastName}`,
              phoneNumber: this.newOwner.phoneNumber,
              email: this.newOwner.email,
              address: this.newOwner.address,
              sex: this.newOwner.sex,
              status: this.newOwner.status
            }),
            // Add new house fields if creating new house
            ...(this.houseType === 'new' && {
              buildingId: this.newHouse.buildingId,
              roomNumber: this.newHouse.roomNumber,
              floor: this.newHouse.floor,
              size: this.newHouse.size
            })
          };
          
          await this.$store.dispatch('registerOwnerOfHouse', ownershipData);
          
          this.$notifications.notify({
            message: 'Ownership agreement successfully created and registered.',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success'
          });
          
          this.$bvModal.hide('modal-center-add');
          this.clearData();
          
        } catch (error) {
          this.$notifications.notify({
            message: (error.response && error.response.data && error.response.data.error) || (error.response && error.response.data) || 'An error occurred while creating the ownership agreement',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
          console.log(error);
        }
      },
      clearData(){
        this.currentStep = 1;
        this.addData.ownerId = null;
        this.addData.houseId = null;
        this.addData.startDate = "";
        this.addData.paymentDate = "";
        this.addData.repaymentAmount = 0;
        this.addData.repaymentFrequency = "";
        this.addData.endDate = "";
        this.addData.gracePeriod = 0;
        this.addData.unpaidTotalAmount = 0;
        this.addData.hasPenalty = false;
        this.addData.penaltyType = "";
        this.addData.penaltyBase = "";
        this.addData.penaltyAmount = 0;
        this.addData.penaltyIncrementDays = 0;
        this.addData.customPenaltyAmount = 0;
        this.addData.customPenaltyIncrementDays = 0;
        this.addData.description = "";
        this.ownerType = 'existing';
        this.houseType = 'existing';
        this.newOwner = {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: '',
          address: '',
          sex: '',
          status: ''
        };
        this.newHouse = {
          buildingId: null,
          roomNumber: null,
          floor: null,
          size: null
        };
        this.$emit('AfterComplete');
      },
      async submitEditForm(){
        console.log('submitEditForm called');
        console.log('selectedOwnership:', this.selectedOwnership);
        
        // Validation for repayment amount vs unpaid total amount
        if (this.selectedOwnership.repaymentAmount >= this.selectedOwnership.unpaidTotalAmount) {
          this.$notifications.notify({
            message: 'Repayment Amount must be less than Unpaid Total Amount',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
          return;
        }
        
        const confirmed = await this.$bvModal.msgBoxConfirm('Are you sure you want to update this ownership?', {
          title: 'Confirm Update',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          cancelVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          bodyClass: 'm-2',
          hideHeaderClose: false,
          centered: false
        });
        
        if (!confirmed) return;
        
        try {
          const editData = {
            houseOwnerId: this.selectedOwnership.houseOwnerId,
            ownerId: this.selectedOwnership.ownerId,
            houseId: this.selectedOwnership.houseId,
            startDate: this.selectedOwnership.startDate,
            repaymentAmount: this.selectedOwnership.repaymentAmount,
            repaymentFrequency: this.selectedOwnership.repaymentFrequency,
            gracePeriod: this.selectedOwnership.gracePeriod,
            unpaidTotalAmount: this.selectedOwnership.unpaidTotalAmount,
            hasPenalty: this.selectedOwnership.hasPenalty,
            penaltyType: this.selectedOwnership.penaltyType,
            penaltyBase: this.selectedOwnership.penaltyBase,
            penaltyAmount: this.selectedOwnership.penaltyAmount,
            penaltyIncrementDays: this.selectedOwnership.penaltyIncrementDays,
            description: this.selectedOwnership.description
          };
          
          console.log('Sending edit data:', editData);
          await this.$store.dispatch('editOwnership', editData);
          
          this.$notifications.notify({
            message: 'Ownership successfully updated.',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success'
          });
          
          this.$bvModal.hide('modal-edit-ownership');
          this.getOwnershipList();
          
        } catch (error) {
          console.error('Edit ownership error:', error);
          let errorMessage = 'An error occurred while updating ownership.';
          
          if (error.response && error.response.data) {
            if (error.response.data.error) {
              errorMessage = error.response.data.error;
            } else if (typeof error.response.data === 'string') {
              errorMessage = error.response.data;
            }
          }
          
          this.$notifications.notify({
            message: errorMessage,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        }
      }
    },
  }
</script>
<style scoped>
.b-table-sticky-column:last-child {
  right: 0;
}
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
}
.btn-icon{
  font-size: 27px !important;
  padding: 3px 5px 3px 5px;
  width: 40px;
  color:  rgb(37, 91, 48);
  border: 2px solid rgb(37, 91, 48);
}
.btn-icon:hover,
.btn-icon:focus {
  cursor: pointer;
  background-color: rgb(37, 91, 48) !important;
  color: rgba(240, 206, 13, 0.937) !important;
  border-radius: 4px;
  transition: .4s;
}

/* Step Progress Styles */
.step-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.step {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #e9ecef;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  transition: all 0.3s ease;
}

.step.active {
  background-color: #007bff;
  color: white;
}

.step-line {
  width: 50px;
  height: 2px;
  background-color: #e9ecef;
  transition: all 0.3s ease;
}

.step-line.active {
  background-color: #007bff;
}

/* Contract Review Styles */
.contract-review-container {
  max-height: 600px;
  overflow-y: auto;
}

.contract-document {
  font-family: 'Times New Roman', serif;
  line-height: 1.6;
  color: #333;
}

.document-header {
  border-bottom: 2px solid #007bff;
  padding-bottom: 15px;
}

.contract-section {
  margin-bottom: 25px;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #007bff;
}

.signature-box {
  background-color: #f8f9fa;
}

.signature-line {
  border-bottom: 1px solid #333 !important;
  margin-top: 20px;
}

.progress {
  border-radius: 10px;
  background-color: #e9ecef;
}

.progress-bar {
  border-radius: 10px;
  transition: width 0.3s ease;
}

.btn {
  border-radius: 25px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.btn:disabled {
  transform: none;
  box-shadow: none;
}

.modal-navigation {
  border-top: 1px solid #dee2e6;
  padding-top: 15px;
}

.section-title {
  color: rgb(37, 91, 48) !important;
  font-weight: 600;
  margin-bottom: 15px;
}

/* Mobile responsiveness */
/* Table Container Styles */
.table-container {
  position: relative;
  overflow-x: auto;
  margin-bottom: 0;
}

.pagination-container {
  background-color: #fff;
  border-top: 1px solid #dee2e6;
  padding: 15px 0;
  margin-top: 0;
}

/* Responsive Table Adjustments */
@media (max-width: 1200px) {
  .table-container {
    max-height: 350px;
  }
}

@media (max-width: 992px) {
  .table-container {
    max-height: 300px;
  }
}

@media (max-width: 768px) {
  .table-container {
    max-height: 250px;
  }
  
  .pagination-container {
    padding: 10px 0;
  }
  
  .contract-document {
    font-size: 0.9rem;
  }
  
  .section-title {
    font-size: 1rem;
  }
  
  .step {
    width: 30px;
    height: 30px;
    font-size: 12px;
  }
  
  .step-line {
    width: 40px;
  }
}

@media (max-width: 576px) {
  .table-container {
    max-height: 200px;
  }
  
  .pagination-container .form-group label {
    font-size: 0.8rem;
  }
}

/* Ensure proper spacing and prevent overlap */
.card-body {
  padding-bottom: 0 !important;
}

.table-full-width {
  margin-bottom: 0 !important;
}

/* Fix sticky column positioning */
.b-table-sticky-column {
  z-index: 10;
}

.table-container .table {
  margin-bottom: 0;
}
</style>